<div style="display: flex; flex-flow: column nowrap; gap: 1em;">

	<div style="display: flex; flex-flow: row wrap; gap: 1em; justify-content: center;">
		<span>Aktueller Status:</span>
		<span>{{statusStrings[ savedType ]}}</span>
	</div>

	<div *ngIf="!bValidationNeeded">

		<div
			*ngIf="(savedType == 'disabled') && !QRSecret"
			style="display: flex; flex-flow: column wrap; gap: 1em; padding: 1em; margin: 1em 0; background: var(--customWhite); border-radius: 1em; border: 1px solid var(--mainColor);"
		>

			<div>Sehr geehrte Mitglieder,</div>
			<div>
				der Schutz aller im Portal verwalteten Daten hat bei uns höchste Priorität. 
				Der Login erfolgt daher über eine 2 Faktor-Authentifizierung. 
				Hierfür gibt es die Möglichkeit eine App (z.B. Google Authenticator, Microsoft Authenticator oder 2FA Authenticator) zu verwenden oder die Email.
			</div>
	
			<div>Bitte wählen Sie eine Authentifizierungsform:</div>
	
		</div>

		<div style="display: flex; flex-flow: row nowrap; gap: 2em;">

			<button 
				*ngIf="savedType != 'disabled'"
				mat-raised-button
				color="primary" 
				[disabled]="bChangeInProgress"
				style="width: 100%;"
				(click)="disable2FA()">
				Deaktivieren
			</button>
	
			<button 
				*ngIf="savedType == 'disabled'"
				mat-raised-button
				color="primary" 
				[disabled]="bChangeInProgress"
				style="width: 100%;"
				(click)="enable2FAApp()">
				App aktivieren
			</button>
	
			<button 
				*ngIf="savedType == 'disabled'"
				mat-raised-button
				color="primary" 
				[disabled]="bChangeInProgress"
				style="width: 100%;"
				(click)="enable2FAEmail()">
				Email aktivieren
			</button>

		</div>	

	</div>



	<div *ngIf="QRSecret && typeInProgress == 'authenticator'">

		<div *ngIf="QRSecret == 'error'" style="color: red">
			Fehler beim Laden des QR-Codes
		</div>
		<div
			*ngIf="QRSecret != 'error'"
			style="background-color: var(--customWhite); padding: 1em;"
		>

			<div>
				<div>Für die App Aktivierung können Sie eine der folgenden Apps benutzen</div>
				<ul>
					<li>Google Authenticator (Android)</li>
					<li>Microsoft Authenticator (Android & IOS)</li>
					<li>2FA Authenticator (Android)</li>
				</ul>
				<div>Um die 2-Faktor-Authentifizierung zu aktivieren, installieren Sie eine der beiden Apps und scannen den folgenden QR-Code in der installierten Anwendung:</div>
			</div>

			<!-- <div style="text-align: center;">
				<img src="https://chart.googleapis.com/chart?chs=200x200&cht=qr&chl=200x200&chld=M|0&cht=qr&chl=otpauth://totp/ARGE Rück Mitgliederportal?secret={{QRSecret}}">
			</div> -->
			<div style="display: flex; justify-content: center;">
				<qr-code
					[value]="'otpauth://totp/ARGE Rück Mitgliederportal?secret=' + QRSecret"
					[size]="250"
					errorCorrectionLevel="M">
				</qr-code>

			</div>
			<div style="color: rgba(0, 0, 0, 0.54); font-size: smaller;display: flex ;justify-content: center;">Sie können diesen Code auch manuell eingeben:</div>
			<div style="display: flex; justify-content: center;">{{QRSecret}}</div>
		</div>

	</div>

	
	<div *ngIf="bValidationNeeded">

		<div *ngIf="typeInProgress == 'authenticator'">

			<div style="margin: 1em 0; font-size: large; display: flex; justify-content: center;">
				Authenticator
			</div>
			<div style="align-items: center;">
				Bitte geben Sie den Code aus dem Authenticator ein:
			</div>

		</div>
		<div *ngIf="typeInProgress == 'email'">

			<div style="margin: 1em 0; font-size: large;">
				E-Mail
			</div>
			<div *ngIf="bRequestForEmailFailed && !bChangeInProgress" style="color: red;">
				<div>Beim Senden der E-Mail an Sie ist ein Fehler aufgetreten.</div>
				<div>Bitte wenden Sie sich an Ihren Administrator</div>
			</div>
			<div *ngIf="!bRequestForEmailFailed && !bChangeInProgress">
				<div>Ein Code wurde an Ihre E-Mail-Adresse gesendet.</div>
				<div>Bitte schreiben Sie es hier auf:</div>
			</div>

		</div>

		<div style="text-align: center;">
			<totp-input 
				*ngIf="!bRequestForEmailFailed"
				style="display: inline-block;"
				(totpReady)="onTotpReady($event)"></totp-input>
		</div>


		<div style="display: flex; flex-flow: row wrap; gap: 2em; margin: 2em 0; justify-content: center;">
			<button mat-raised-button
				color="secondary" 
				[disabled]="bChangeInProgress"
				(click)="cancelValidation()"
			>
				Abbrechen
			</button>
			<button mat-raised-button
				color="primary" 
				[disabled]="bChangeInProgress || (totpCode.length != 6) || bRequestForEmailFailed"
				(click)="validateF2A()">
				Bestätigen
			</button>

		</div>

	</div>

</div>
